module.exports = __webpack_public_path__ + "img/media_slide.58c804dd.jpg";